import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonRectangleComponent } from '@ui/common/buttons';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'ui-cookies-info',
  templateUrl: './cookies-info.component.html',
  styleUrls: ['./cookies-info.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, ButtonRectangleComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiesInfoComponent {
  @Output() actionClick = new EventEmitter<boolean>();

  onAcceptClick(): void {
    this.actionClick.emit(true);
  }

  onDeclineClick(): void {
    this.actionClick.emit(false);
  }
}
